var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"employee-report","fluid":"","tag":"section"}},[_c('FilterForm',{attrs:{"filterForm":_vm.filterForm,"ministries":_vm.ministries}}),_c('ContactSourceReportTable',{attrs:{"dataReport":_vm.dataReport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }